<template>
  <div class="l-wrap">
    <h1 class="logo">
      <img src="../assets/images/logo.png" alt="DGB대구은행" />
    </h1>
    <section class="index-section">
      <h2>비밀번호 변경</h2>
      <p class="sub-txt validation-msg">최초 1회 비밀번호 변경은 필수입니다.</p>
      <div class="input-wrap">
        <div class="id-area">
          <label>
            비밀번호
            <input type="password" name="pw" placeholder="비밀번호를 입력하세요." autocomplete="off" />
          </label>
        </div>
        <div class="pw-area">
          <label>
            비밀번호 재입력
            <input type="password" name="pw" placeholder="비밀번호를 입력하세요." autocomplete="off" />
          </label>
        </div>
      </div>
    </section>
    <div class="btn btn-blue">
      <span>비밀번호 변경</span>
    </div>
    <div class="btn btn-gray">
      <span>취소</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChangePw',
  data () {
    return {
      saveIdCheck: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ChangePw.vue